import { render } from "./RecoverPasswordComponent.vue?vue&type=template&id=58ef1f10&scoped=true&ts=true"
import script from "./RecoverPasswordComponent.vue?vue&type=script&lang=ts"
export * from "./RecoverPasswordComponent.vue?vue&type=script&lang=ts"

import "./RecoverPasswordComponent.vue?vue&type=style&index=0&id=58ef1f10&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ef1f10"]])

export default __exports__